import dayjs from "dayjs";
import { getEntryStatusLabel } from "src/utils/entryStatus";

export const mapReviewReport = (res: any) => {
  const data = res.data;
  if (!data) return;
  const type = getEntryStatusLabel(data.audittype);
  const date = data.auditdate;
  const sigtype = data.audittype === 1000 ? "AUDITOR" : "REVIEWER";
  let comments: any = [];
  let entries: any = [];

  if (data.comments && data.comments.length > 0) {
    comments = data.comments.map((c: any) => ({
      header:
        (c.role ? c.role + " - " : "") +
        c.fname +
        " " +
        c.sname +
        "   " +
        dayjs(c.date).format("D MMM YYYY HH:mm"),
      content: c.message,
    }));
  }

  let reviewer = data.reviewer?.flag ?? "";
  reviewer += data.reviewer?.role ?? "";
  if (reviewer) reviewer += " - ";
  reviewer += data.reviewer?.name ?? "";

  if (data.result && data.result.length > 0) {
    entries = data.result
      .filter((r: any) => r !== false && r !== null)
      .map((r: any) => {
        const status = getEntryStatusLabel(r.status);
        const date = dayjs(r.datecreated).format("D MMM YYYY - HH:mm");
        let comments = [];
        if (r.reverify && r.reverify.length > 0) {
          comments = r.reverify.map((c: any) => ({
            header:
              (c.role ? c.role + " - " : "") +
              c.fname +
              " " +
              c.sname +
              "   " +
              dayjs(c.date).format("D MMM YYYY - HH:mm"),
            content: c.message,
          }));
        }

        return {
          ref: r.unum + " - " + r.enum,
          title: r.lbname,
          date,
          status,
          comments,
          partid: r.partid,
          lbeid: r.lbeid,
          meid: r.meid,
        };
      });
  }
  return {
    date,
    type,
    sigtype,
    comments,
    entries,
    reviewer,
    yachtuser: data.usertype !== 8 && data.usertype !== 9,
  };
};
